module.exports = __webpack_public_path__ + "static/media/in.f3a60ba3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/in.svg
// module id = 150
// module chunks = 0